(function () {
  function initStickyAtc() {
    const bar = document.querySelector('[data-atj-sticky-atc]');
    const anchor = document.querySelector(
      '.custom-product-info__add-to-cart .atj-btn--product, .atj-product-form .product-form__submit, form[data-type="add-to-cart-form"] [name="add"], .product-form__submit'
    );
    if (!bar || !anchor) return;

    // Escape transformed ancestors so position:fixed sticks to viewport
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    const formId = bar.dataset.formId;
    const form = (formId && document.getElementById(formId)) || anchor.closest('form');
    const submitBtn = bar.querySelector('[data-sticky-atc-submit]');
    const stickyColors = bar.querySelector('[data-sticky-atc-colors]');

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', Boolean(visible));
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const isAnchorInViewport = () => {
      const rect = anchor.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom > 12 && rect.top < vh - 12;
    };

    // Default: hide until we know ATC is out of view
    setVisible(false);

    const getSelectedColorValue = () => {
      const mainSelected =
        document.querySelector('[data-custom-color-swatches] [data-color-swatch].is-selected') ||
        document.querySelector('[data-custom-color-swatches] [data-color-swatch][aria-pressed="true"]');
      if (mainSelected?.dataset?.optionValue) return mainSelected.dataset.optionValue;

      const label = document.querySelector('[data-selected-color-value]')?.textContent?.trim();
      if (label) return label;

      const checked = form?.querySelector('input[type="radio"]:checked');
      if (checked?.value && checked.value !== 'Default Title') return checked.value;

      const stickySelected = stickyColors?.querySelector('[data-sticky-atc-swatch].is-selected');
      return stickySelected?.dataset?.optionValue || '';
    };

    const syncStickySwatches = (colorValue) => {
      if (!stickyColors) return;
      const value = colorValue || getSelectedColorValue();
      stickyColors.querySelectorAll('[data-sticky-atc-swatch]').forEach((btn) => {
        const selected = Boolean(value) && btn.dataset.optionValue === value;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };

    const selectMainColor = (colorValue) => {
      if (!colorValue) return false;

      const mainSwatch = document.querySelector(
        `[data-custom-color-swatches] [data-color-swatch][data-option-value="${CSS.escape(colorValue)}"]`
      );
      if (mainSwatch && !mainSwatch.disabled) {
        mainSwatch.click();
        return true;
      }

      // Fallback: drive native variant radios (Dawn variant-selects)
      const scope = document.querySelector('variant-selects') || document.querySelector('product-info');
      if (!scope) return false;
      const radios = scope.querySelectorAll('input[type="radio"]');
      let match = null;
      radios.forEach((radio) => {
        if (radio.value !== colorValue) return;
        const optionName = radio.dataset.optionName || '';
        if (/color|colour|krāsa|krasa/i.test(optionName) || /^color-/i.test(radio.name || '') || radio.name === 'option1') {
          match = radio;
        }
      });
      if (!match) {
        radios.forEach((radio) => {
          if (radio.value === colorValue) match = radio;
        });
      }
      if (!match || match.disabled) return false;
      if (!match.checked) {
        match.checked = true;
        match.dispatchEvent(new Event('input', { bubbles: true }));
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    };

    submitBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      const primary =
        form?.querySelector('[name="add"][type="submit"], button.product-form__submit, .atj-btn--product') ||
        anchor;
      if (primary && !primary.disabled) {
        primary.click();
      }
    });

    stickyColors?.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-sticky-atc-swatch]');
      if (!swatch || !stickyColors.contains(swatch) || swatch.disabled) return;
      event.preventDefault();
      const colorValue = swatch.dataset.optionValue;
      syncStickySwatches(colorValue);
      selectMainColor(colorValue);
      requestAnimationFrame(syncStickyFromDom);
      setTimeout(syncStickyFromDom, 120);
    });

    const syncStickyFromDom = () => {
      const current = document.querySelector('.atj-product-price-block__current, .price__regular .price-item--regular, .price-item--sale');
      const compare = document.querySelector('.atj-product-price-block__compare, .price__sale .price-item--regular s, .price__compare');
      const stickyCurrent = bar.querySelector('[data-sticky-atc-price]');
      const stickyCompare = bar.querySelector('[data-sticky-atc-compare]');
      const stickyMedia = bar.querySelector('[data-sticky-atc-media]');
      const stickyVariant = bar.querySelector('[data-sticky-atc-variant]');

      if (stickyCurrent && current) {
        stickyCurrent.textContent = current.textContent.trim();
      }
      if (stickyCompare) {
        // Only show compare when the main price block shows one (avoid stale compare_at)
        const compareVisible =
          compare &&
          !compare.hidden &&
          getComputedStyle(compare).display !== 'none' &&
          compare.textContent?.trim();
        if (compareVisible) {
          stickyCompare.textContent = compareVisible;
          stickyCompare.hidden = false;
        } else {
          stickyCompare.textContent = '';
          stickyCompare.hidden = true;
        }
      }

      const colorValue = getSelectedColorValue();
      syncStickySwatches(colorValue);

      // Text variant label only when there is no colour swatch group
      if (stickyVariant && !stickyColors) {
        let label = colorValue;
        if (!label) {
          const checked = form?.querySelector('input[type="radio"]:checked');
          label = checked?.value || checked?.nextElementSibling?.textContent?.trim() || '';
        }
        if (label && label !== 'Default Title') {
          stickyVariant.textContent = label;
          stickyVariant.hidden = false;
        } else {
          stickyVariant.hidden = true;
        }
      } else if (stickyVariant && stickyColors) {
        stickyVariant.hidden = true;
      }

      const activeThumb =
        document.querySelector(
          '.custom-gallery__main-image.is-active, .custom-gallery__main-image.is-visible, .custom-gallery__thumbnail.is-active-thumb, .product__media-item.is-active img, [data-atj-gallery] .is-active img, .atj-vcg__slide.is-active img, .product-media-container.is-active img'
        ) || document.querySelector('.custom-gallery__main-image, .product__media img, .atj-product-gallery img, .product-media-container img');
      if (stickyMedia && activeThumb?.src) {
        let img = stickyMedia.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.className = 'atj-product-sticky-atc__img';
          img.loading = 'lazy';
          img.alt = bar.dataset.productTitle || '';
          stickyMedia.appendChild(img);
        }
        const src = activeThumb.currentSrc || activeThumb.src;
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      }

      const primary = form?.querySelector('[name="add"][type="submit"], .product-form__submit, .atj-btn--product');
      if (submitBtn && primary) {
        submitBtn.disabled = primary.disabled;
        submitBtn.classList.toggle('atj-btn--sold-out', primary.classList.contains('atj-btn--sold-out'));
        const label =
          primary.querySelector('.atj-btn__text, span')?.textContent?.trim() ||
          primary.textContent?.trim();
        if (label) submitBtn.textContent = label.replace(/\s+/g, ' ').trim();
      }
    };

    if (typeof IntersectionObserver === 'undefined') {
      setVisible(!isAnchorInViewport());
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          const inView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0);
          setVisible(!inView);
        },
        { root: null, threshold: [0, 0.01, 0.1], rootMargin: '0px 0px -8px 0px' }
      );
      observer.observe(anchor);
      // Correct first paint before observer callback
      setVisible(!isAnchorInViewport());
    }

    syncStickyFromDom();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        requestAnimationFrame(syncStickyFromDom);
      });
    }

    document.addEventListener('change', (event) => {
      if (
        event.target?.closest?.('variant-selects') ||
        event.target?.closest?.('[data-custom-color-swatches]') ||
        event.target?.closest?.('product-form') ||
        event.target?.name === 'quantity'
      ) {
        syncStickyFromDom();
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target?.closest?.('[data-color-swatch], .product-form__input label, [data-custom-color-swatches]')) {
        requestAnimationFrame(syncStickyFromDom);
        setTimeout(syncStickyFromDom, 120);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
